import { useEffect, useState } from 'react';

import { getContractsCo } from '../../../domains/contracts/getContracts';

export const useGetContracts = function (productType) {
  const [contracts, setContracts] = useState([]);

  const fetchContracts = async () => {
    try {
      const contractsResponse = await getContractsCo(productType);
      setContracts(contractsResponse);
    } catch (error) {
      setContracts(null);
    }
  };

  useEffect(() => {
    fetchContracts();
  }, []);

  return contracts;
};
